module.exports = __webpack_public_path__ + "media/images/picto_logement_entier-6d468e2d61836ca3442f0827e988de4e.svg";